import React from 'react';
import Request from 'superagent';
import AuthService from '../../AuthService';
import { globales, funciones } from '../../global';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, CircularProgress, IconButton, TextField, MenuItem,
         Dialog,DialogTitle,DialogContent,DialogActions,Button,Radio,RadioGroup,FormControlLabel,Grid} from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import BarraBotones   from '../../components/Barra_menu';

let Auth = new AuthService()
let tokenInfo = []
const esMovil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

const columnas = [
  { id: 'ID_CURSO', label: 'ID_CURSO', align: 'center', hidden: true },
  { id: 'ID_SECCION', label: 'ID_SECCION', align: 'center', hidden: true },
  { id: 'CODIGO_CURSO', label: 'Código', align: 'left', filterKey: 'filtroCodigo' },
  { id: 'DESCRIPCION_CURSO', label: 'Descripción', align: 'left', filterKey: 'filtroCurso' },
  { id: 'CREDITOS', label: 'UV', align: 'center', filterKey: 'filtroCreditos' }, 
  { id: 'MODALIDAD', label: 'Modalidad', align: 'center', filterKey: 'filtroModalidad' },
  { id: 'JORNADA', label: 'Jornada', align: 'center', filterKey: 'filtroJornada' },
  { id: 'DIAS', label: 'Días', align: 'center' },
]

const styles = theme => ({
  root: {
    width: '90%',
    overflow: 'hidden',
    margin: '-1% 5% ' //tabla
  },
  tableContainer: {
    maxHeight: 'clamp(200px, calc(100vh - 258px), 990px)',
    overflowX: 'auto',
    overflowY: 'auto',

    [theme.breakpoints.down('sm')]: {
      maxHeight: 'clamp(260px, calc(100vh - 320px), 890px)'
    }
  },
  overlayLoader: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    backgroundColor: 'rgba(255,255,255,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  headCell: {
    color: '#fff',
    fontWeight: 'bold',
    backgroundColor: '#042a53',
    whiteSpace: 'nowrap',
    paddingTop: 10,
    paddingBottom: 11
  },
  bodyCellResponsive: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      paddingLeft: 6,
      paddingRight: 6
    }
  },
  table: {
    width: '100%',
    overflowY: 'scroll'
  },
  filtroInput: {
    '& .MuiInputBase-root': {
      height: 25,
      fontSize: 14,
      backgroundColor: '#fff'
    },
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid #d0d0d0'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid #042a53'
    },
    '& .MuiInput-underline:after': {
      borderBottom: '2px solid #042a53'
    },
    '& .MuiInputBase-input': {
      paddingTop: 3,
      paddingBottom: 3
    }
  },
  headStickyRow: {
    '& th': {
      position: 'sticky',
      top: 0,
      zIndex: 3,
      backgroundColor: '#042a53'
    }
  },
  filterStickyRow: {
    '& th': {
      position: 'sticky',
      top: 43,
      zIndex: 2,
      backgroundColor: '#fff'
    }
  },
  filterStickyCell: {
    backgroundColor: '#fff',
    paddingTop: 2,
    paddingBottom: 2,
    borderBottom: '1px solid #dcdcdc'
  },
  selectionHeadCell: {
    width: 120,
    minWidth: 120,
    maxWidth: 120,
    paddingLeft: 4,
    paddingRight: 4
  },
  selectionFilterCell: {
    minWidth: 120,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 1,
    paddingBottom: 1,
    backgroundColor: '#fff',
    borderBottom: '1px solid #dcdcdc'
  }
})

export default withStyles(styles)(
class TablaOferta extends React.Component {
  constructor(props) {
    super(props);

    this.electivasOpens = [];
    this.optativasCache = {};
    this.filterTimer = null;

    this.state = {
      isLoggin: true,
      rows: [],
      expandedGroups: [],
      expandedRowIds: [],
      selection: [],
      loadingMain: true,
      loadingSeleccion: false,
      openBackDropInvisible: false,
      cuenta: '',
      filtroCodigo: '',
      filtroCurso: '',
      filtroJornada: '',
      filtroModalidad: '',
      filtroCreditos: '',
      filtroSeleccion: 'Todos',
      
      rowsdias:[],
      modalDias:false,
      diaSeleccionado:'',
      rowPendienteDia:null,
      anchoPantalla: window.innerWidth,
      //Informacion Cliente
      rowsInformacionCliente:[]
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    tokenInfo = Auth.getProfile();

    this.setState(
      {
        isLoggin: tokenInfo.plataforma !== undefined ? true : false
      },
      () => {
        if (tokenInfo.plataforma === 2) {
          this.obtenerOferta()
          this.obtenerInformacionCliente()
        }
      }
    );
  }

  componentWillUnmount() {
    if (this.filterTimer) {
      clearTimeout(this.filterTimer);
    }
  }

  handleFilterChange = (key, value) => {
    this.setState({ [key]: value })
  }

  obtenerOferta = () => {
    new Request
      .get(`${globales.ip}/IntencionMatricula/oferta/${tokenInfo.user}/${tokenInfo.sucursal}`)
      .set({ authorization: 'Bearer ' + Auth.getToken() })
      .retry(1)
      .timeout({ response: 15000, deadline: 30000 })
      .end((err, res) => {
        if (err) {
          if (String(err).substr(0, 16) === 'Error: Forbidden') {
            window.location.reload();
            return
          }

          this.setState(
            {
              rows: [],
              expandedGroups: [],
              selection: [],
              loadingMain: false
            },
            () => {
              funciones.showToast('e', 'No hay conexión')
            }
          );
          return
        }

        try {
          const rowsOferta = JSON.parse(res.text)

          const rowsFiltradas = Array.isArray(rowsOferta)
            ? rowsOferta.filter(item => {
                if (Number(item.OPTATIVA) !== 1) return true
                return Number(item.OPTATIVA_HIJOS) === 1
              })
            : [];

          const infoTable = this.formatRows(rowsFiltradas)

          this.setState({
            rows: infoTable.rows,
            expandedGroups: infoTable.expandedGroup,
            selection: infoTable.selection,
            loadingMain: false
          });

        } catch (e) {
          this.setState(
            {
              rows: [],
              expandedGroups: [],
              selection: [],
              loadingMain: false
            },
            () => {
              funciones.showToast('e', 'Error procesando la oferta')
            }
          )
        }
      })
  }

  fetchOptativas = idSeccion => {

    const key = String(idSeccion)

    if (this.optativasCache[key]) {
      return Promise.resolve(this.optativasCache[key])
    }

    return new Promise(resolve => {
      new Request
        .get(`${globales.ip}/IntencionMatricula/oferta_optativa/${tokenInfo.user}/${parseInt(idSeccion)}/${tokenInfo.sucursal}`)
        .set({ authorization: 'Bearer ' + Auth.getToken() })
        .retry(1)
        .timeout({ response: 15000, deadline: 30000 })
        .end((err, res) => {
          if (err) {
            this.optativasCache[key] = []
            resolve([])
            return;
          }

          try {
            const data = JSON.parse(res.text)
            const safeData = Array.isArray(data) ? data : []
            this.optativasCache[key] = safeData
            resolve(safeData)

          } catch (e) {
            this.optativasCache[key] = []
            resolve([])
          }
        })
    })
  }

obtenerDias= (row) => {
    new Request
      .get(`${globales.ip}/IntencionMatricula/gestiondias/${tokenInfo.user}/${row.ID_MODALIDAD}/${row.ID_JORNADA}`)
      .set({ authorization: 'Bearer ' + Auth.getToken() })
      .retry(1)
      .timeout({ response: 15000, deadline: 30000 })
      .end((err, res) => {

        if (err) {
          if (err.toString().includes('Forbidden')) {
            window.location.reload();
            return;
          }
          funciones.showToast('e', 'No hay conexión')
          return;
        }
       try {
            const rows = JSON.parse(res.text)

            this.setState({
            rowsdias: Array.isArray(rows) ? rows : [],
            modalDias: true,
            diaSeleccionado: rows.length > 0 ? rows[0].ID_DIA : '',
            rowPendienteDia: row
            })
       } catch (e) {
        funciones.showToast('e', 'Error al obtener los días');
       }
      
    })
  }

obtenerInformacionCliente= () => {
    new Request
      .get(`${globales.ip}/IntencionMatricula/InformacionCliente/${tokenInfo.user}`)
      .set({ authorization: 'Bearer ' + Auth.getToken() })
      .retry(1)
      .timeout({ response: 15000, deadline: 30000 })
      .end((err, res) => {

        if (err) {
          if (err.toString().includes('Forbidden')) {
            window.location.reload();
            return
          }
          funciones.showToast('e', 'No hay conexión');
          return
        }
       try {
            const rows = JSON.parse(res.text)

            this.setState({ rowsInformacionCliente: rows })
       } catch (e) {
        funciones.showToast('e', 'Error al obtener los días')
       }
      
    })
  }


  getRowCheckKey = row => {
    return [
      row.ID_SECCION,
      row.ID_JORNADA,
      row.ID_MODALIDAD,
      row.CODIGO_CURSO
    ].join('-')
  }

  formatRows = rows => {
    const safeRows = Array.isArray(rows)
      ? rows.filter(item => {
          if (Number(item.OPTATIVA) !== 1) return true
          return Number(item.OPTATIVA_HIJOS) === 1
        })
      : []

    const grouped = new Map()
    const allGroupsSet = new Set()
    const selection = []

    safeRows.forEach(item => {
      const key = `${item.PERIODO}|${item.ID_PLAN}|${item.CODIGO_CURSO}`
      const planKey = String(item.ID_PLAN);
      const periodoKey = `${item.ID_PLAN}|${item.PERIODO}`

      allGroupsSet.add(planKey)
      allGroupsSet.add(periodoKey)

      const detail = {
        ...item,
        TREE: null,
        HDR: 0,
        CHECKED: Number(item.CHECKED) === 1 ? 1 : 0
      }

      detail.CHECK_KEY = this.getRowCheckKey(detail)

      if (Number(detail.CHECKED) === 1) {
        selection.push(detail.CHECK_KEY)
      }

      if (!grouped.has(key)) {
        grouped.set(key, {
          parent: {
            ...item,
            HDR: 1,
            CHECKED: Number(item.CHECKED) === 1 ? 1 : 0,
            CHECK_KEY: `PAR-${item.PERIODO}-${item.ID_PLAN}-${item.CODIGO_CURSO}`,
            TREE: [],
            OPTATIVA_CARGADA: Number(item.OPTATIVA) === 1 ? false : true
          },
          details: []
        })
      }

      grouped.get(key).details.push(detail);
    })

    const parentRows = Array.from(grouped.values()).map(group => {
      const { parent, details } = group

      return {
        ...parent,
        TREE: Number(parent.OPTATIVA) === 1 ? [] : details
      }
    })

    return {
      rows: parentRows,
      selection: [...new Set(selection)],
      expandedGroup: Array.from(allGroupsSet)
    }
  }

  formatOptativeRows = (rows, idElectiva) => {
    if (!Array.isArray(rows) || rows.length === 0) {
      return { rows: [], selection: [...this.state.selection] }
    }

    const normalizedRows = rows.map((item, index) => {
      const newRow = {
        ...item,
        ORIGINAL_ID_SECCION: item.ID_SECCION,
        ID_SECCION: `${item.ID_SECCION}-${idElectiva}-${index}`,
        ID_SECCION_PADRE: idElectiva,
        TREE_ORIGINAL: item.TREE,
        TREE: [],
        HDR: 0,
        CHECKED: Number(item.CHECKED) === 1 ? 1 : 0
      }

      return {
        ...newRow,
        CHECK_KEY: this.getRowCheckKey(newRow)
      }
    })

    const idMap = new Map();
    normalizedRows.forEach(row => { idMap.set(String(row.ORIGINAL_ID_SECCION), row) });

    const rootRows = []

    normalizedRows.forEach(row => {
      const parentId = row.TREE_ORIGINAL

      if (
        parentId !== null &&
        parentId !== undefined &&
        String(parentId).trim() !== '' &&
        idMap.has(String(parentId))
      ) {
        const parent = idMap.get(String(parentId))

        if (!Array.isArray(parent.TREE)) {
          parent.TREE = []
        }

        parent.TREE.push(row)
      } else {
        rootRows.push(row)
      }
    })

    const sortTree = list => {
      return list
        .sort((a, b) => {
          if (String(a.CODIGO_CURSO || '') < String(b.CODIGO_CURSO || '')) return -1
          if (String(a.CODIGO_CURSO || '') > String(b.CODIGO_CURSO || '')) return 1
          if (String(a.DESCRIPCION_CURSO || '') < String(b.DESCRIPCION_CURSO || '')) return -1
          if (String(a.DESCRIPCION_CURSO || '') > String(b.DESCRIPCION_CURSO || '')) return 1
          return 0;
        })
        .map(item => ({
          ...item,
          TREE: Array.isArray(item.TREE) ? sortTree(item.TREE) : []
        }))
    }

    const sortedRows = sortTree(rootRows);

    const checkedSelection = [];
    const walkChecked = list => {
      if (!Array.isArray(list)) return;

      list.forEach(item => {
        if (Number(item.CHECKED) === 1) {
          checkedSelection.push(item.CHECK_KEY);
        }

        if (Array.isArray(item.TREE) && item.TREE.length > 0) {
          walkChecked(item.TREE);
        }
      })
    }

    walkChecked(sortedRows);

    return {
      rows: sortedRows,
      selection: [...new Set([...this.state.selection, ...checkedSelection])]
    }
  }

  findRowById = (rows, id) => {
    if (!Array.isArray(rows)) return null

    for (let i = 0; i < rows.length; i++) {
      const item = rows[i]

      if (String(item.ID_SECCION) === String(id)) {
        return item
      }

      if (Array.isArray(item.TREE) && item.TREE.length > 0) {
        const found = this.findRowById(item.TREE, id)
        if (found) return found
      }
    }

    return null
  }

  updateParentCheckedFromChildren = (rows, idPadre) => {
    if (!Array.isArray(rows)) return rows;

    return rows.map(item => {
      if (String(item.ID_SECCION) === String(idPadre)) {
        const hasChecked = Array.isArray(item.TREE) && this.hasCheckedChildren(item.TREE)
        return {
          ...item,
          CHECKED: hasChecked ? 1 : 0
        };
      }

      if (Array.isArray(item.TREE) && item.TREE.length > 0) {
        return {
          ...item,
          TREE: this.updateParentCheckedFromChildren(item.TREE, idPadre)
        };
      }

      return item
    })
  }

  setOptativasInMemory = (currentRows, rowsOptativas, idSeccion) => {
    const updateRows = rows => {
      if (!Array.isArray(rows)) return rows;

      return rows.map(item => {
        if (String(item.ID_SECCION) === String(idSeccion)) {
          const hasChecked = Array.isArray(rowsOptativas) && this.hasCheckedChildren(rowsOptativas)
          return {
            ...item,
            TREE: Array.isArray(rowsOptativas) ? rowsOptativas : [],
            OPTATIVA_CARGADA: true,
            CHECKED: hasChecked ? 1 : Number(item.CHECKED) === 1 ? 1 : 0
          }
        }

        if (Array.isArray(item.TREE) && item.TREE.length > 0) {
          return {
            ...item,
            TREE: updateRows(item.TREE)
          };
        }

        return item
      })
    }

    return updateRows(currentRows)
  };

  changeExpandedRowIds = expandedRowIds => {
    const rowChanged = funciones.getIdRowChecking(
      expandedRowIds,
      this.state.expandedRowIds
    );

    if (!rowChanged) {
      this.setState({ expandedRowIds })
      return;
    }

    const rowId = String(rowChanged).split('-')[0];
    const rowData = this.findRowById(this.state.rows, rowId);

    if (
      this.electivasOpens.find(x => String(x) === String(rowId)) ||
      rowData === null ||
      Number(rowData.OPTATIVA) === 0
    ) {
      this.setState({ expandedRowIds })
      return;
    }

    this.electivasOpens.push(rowId)

    this.setState(
      {
        expandedRowIds,
        openBackDropInvisible: true
      },
      () => {
        this.fetchOptativas(rowId)
          .then(rows => {
            const safeRows = Array.isArray(rows) ? rows : [];

            if (safeRows.length > 0) {
              const infoTable = this.formatOptativeRows(safeRows, rowId);

              this.setState(prevState => ({
                rows: this.setOptativasInMemory(prevState.rows, infoTable.rows, rowId),
                selection: infoTable.selection,
                openBackDropInvisible: false
              }));
            } else {
              this.setState(prevState => ({
                rows: this.setOptativasInMemory(prevState.rows, [], rowId),
                openBackDropInvisible: false
              }));
            }
          })
          .catch(() => {
            this.electivasOpens = this.electivasOpens.filter(
              x => String(x) !== String(rowId)
            );

            this.setState(prev => ({
              expandedRowIds: prev.expandedRowIds.filter(
                x => String(x) !== String(rowId)
              ),
              openBackDropInvisible: false
            }))
          })
      }
    )
  }

  handleToggleExpanded = rowId => {
    const { expandedRowIds = [] } = this.state;
    const id = String(rowId);

    const newExpanded = expandedRowIds.includes(id)
      ? expandedRowIds.filter(x => x !== id)
      : [...expandedRowIds, id];

    this.changeExpandedRowIds(newExpanded);
  };

  getSelectedDetails = rows => {
    let result = [];

    const walk = list => {
      if (!Array.isArray(list)) return;

      list.forEach(item => {
        if (Number(item.HDR) === 0 && Number(item.CHECKED) === 1) {
          result.push(item);
        }

        if (Array.isArray(item.TREE) && item.TREE.length > 0) {
          walk(item.TREE);
        }
      });
    };

    walk(rows);
    return result;
  };

handleCheckCurso = async row => {
  const targetKey = row.CHECK_KEY;
  const isCurrentlyChecked = Number(row.CHECKED) === 1

  // DESMARCAR
  if (isCurrentlyChecked) {
    try {
      this.setState({ loadingSeleccion: true })

      await this.guardarIntencionMatricula(row, 2)

      this.setState(prevState => {
        let updatedRows = this.updateRow(prevState.rows, targetKey, {
          CHECKED: 0,
          ID_DIAS: '',
          DIAS: ''
        })

        if (row.ID_SECCION_PADRE) {
          updatedRows = this.updateParentCheckedFromChildren(
            updatedRows,
            row.ID_SECCION_PADRE
          )
        }

        const nuevaSeleccion = prevState.selection.filter( x => x !== targetKey )

        return {
          rows: updatedRows,
          selection: nuevaSeleccion,
          filtroSeleccion:
            prevState.filtroSeleccion === 'Seleccionados' &&
            nuevaSeleccion.length === 0
              ? 'Todos'
              : prevState.filtroSeleccion,
          loadingSeleccion: false
        };
      });
    } catch (error) {
      this.setState({ loadingSeleccion: false });
      funciones.showToast('e', 'No se pudo eliminar la selección')
    }

    return
  }

  const selectedDetails = this.getSelectedDetails(this.state.rows)

  const sameCourseSelected = selectedDetails.find(
    item =>
      item.CODIGO_CURSO === row.CODIGO_CURSO &&
      item.CHECK_KEY !== row.CHECK_KEY
  );

  if (sameCourseSelected) {
    funciones.showToast( 'w', 'No puede seleccionar el mismo curso en diferente jornada.' )
    return
  }

  // SELECCIONAR
  this.obtenerDias(row);
};

  hasCheckedChildren = rows => {
    if (!Array.isArray(rows)) return false

    return rows.some(item => {
      if (Number(item.CHECKED) === 1) return true

      if (Array.isArray(item.TREE) && item.TREE.length > 0) {
        return this.hasCheckedChildren(item.TREE)
      }

      return false
    })
  }

    normalizarTexto = texto => {
    return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
    };

    cumpleFiltros = row => {
    const {
        filtroCodigo,
        filtroCurso,
        filtroJornada,
        filtroModalidad,
        filtroCreditos,
        filtroSeleccion
    } = this.state

    const isSelected = Number(row.CHECKED) === 1
    const valorSeleccion = String(filtroSeleccion || 'Todos')

    const textoCodigo = this.normalizarTexto(row.CODIGO_CURSO)
    const textoCurso = this.normalizarTexto(row.DESCRIPCION_CURSO)
    const textoJornada = this.normalizarTexto(row.JORNADA)
    const textoModalidad = this.normalizarTexto(row.MODALIDAD)
    const textoCreditos = this.normalizarTexto(row.CREDITOS)

    const filtroCodigoNorm = this.normalizarTexto(filtroCodigo)
    const filtroCursoNorm = this.normalizarTexto(filtroCurso)
    const filtroJornadaNorm = this.normalizarTexto(filtroJornada)
    const filtroModalidadNorm = this.normalizarTexto(filtroModalidad)
    const filtroCreditosNorm = this.normalizarTexto(filtroCreditos)

    const matchSeleccion =
        valorSeleccion === 'Todos' ||
        (valorSeleccion === 'Seleccionados' && isSelected)

    const matchCodigo = !filtroCodigoNorm || textoCodigo.includes(filtroCodigoNorm)

    const matchCurso = !filtroCursoNorm || textoCurso.includes(filtroCursoNorm)

    const matchJornada = !filtroJornadaNorm || textoJornada.includes(filtroJornadaNorm)

    const matchModalidad = !filtroModalidadNorm || textoModalidad.includes(filtroModalidadNorm)
    const matchCreditos = !filtroCreditosNorm || textoCreditos.includes(filtroCreditosNorm)

    return (
        matchCodigo &&
        matchCurso &&
        matchJornada &&
        matchModalidad &&
        matchCreditos &&
        matchSeleccion
    )
    }

    tieneSeleccionados = () => {
    const recorrer = rows => {
        if (!Array.isArray(rows)) return false;

        return rows.some(row => {
        if (Number(row.CHECKED) === 1) return true;

        if (Array.isArray(row.TREE) && row.TREE.length > 0) {
            return recorrer(row.TREE)
        }

        return false
        });
    }

    return recorrer(this.state.rows);
    }


    prepareRowsForRender = rows => {
    if (!Array.isArray(rows)) return []

    return rows.reduce((acc, row) => {
        const preparedChildren = Array.isArray(row.TREE)
        ? this.prepareRowsForRender(row.TREE)
        : [];

        const isHeader = Number(row.HDR) === 1
        const esOptativa = Number(row.OPTATIVA) === 1
        const tieneHijosOptativa = Number(row.OPTATIVA_HIJOS) === 1

        const selfVisible = !isHeader ? this.cumpleFiltros(row) : false
        const hasVisibleChildren = preparedChildren.length > 0
        const hasCheckedChildren = preparedChildren.some(child => child.CHECKED_VISIBLE === true )

        let visible = false

        if (isHeader) {
        const filtroSeleccionados = this.state.filtroSeleccion === 'Seleccionados';

        if (filtroSeleccionados) {
            visible =
            Number(row.CHECKED) === 1 ||
            hasVisibleChildren ||
            hasCheckedChildren
        } else {
            if (esOptativa) {
            visible = tieneHijosOptativa
            } else {
            visible =
                hasVisibleChildren ||
                Number(row.CHECKED) === 1
            }
        }
        } else {
        visible = selfVisible
        }

        if (!visible) {
        return acc
        }

        acc.push({
        ...row,
        TREE: preparedChildren,
        VISIBLE: visible,
        HAS_VISIBLE_CHILDREN: hasVisibleChildren,
        HAS_CHECKED_CHILDREN: hasCheckedChildren,
        CHECKED_VISIBLE: Number(row.CHECKED) === 1 || hasCheckedChildren
        });

        return acc
    }, [])
    }



  renderTreeRows = (rows, level = 0) => {
    const { expandedRowIds = [] } = this.state
    const { classes } = this.props

    if (!Array.isArray(rows)) return null

    let lastPeriodo = null

    return rows.map((row, index) => {
      const expandId = String(row.ID_SECCION);
      const hasChildren =(Array.isArray(row.TREE) && row.TREE.length > 0) || Number(row.OPTATIVA) === 1
      const isExpanded = expandedRowIds.includes(expandId)
      const isHeader = Number(row.HDR) === 1
      const isChecked = Number(row.CHECKED) === 1
      const parentHasCheckedChild = row.HAS_CHECKED_CHILDREN || isChecked

      let backgroundColor = '#fff'


      const showPeriodoHeader = level === 0 && row.PERIODO && row.PERIODO !== lastPeriodo

      if (showPeriodoHeader) {
        lastPeriodo = row.PERIODO
      }

      if (isHeader) {
        backgroundColor = '#f7f7f7'
      }

      if (!isHeader && isChecked) {
        backgroundColor = '#e8f1fb';
      }

      if (isHeader && parentHasCheckedChild) {
        backgroundColor = '#dceaf8' //CUANDO EL CURSO ESTA SELECCIONADO 
      }

      return (
        <React.Fragment key={`${expandId}-${index}`}>
          {showPeriodoHeader && (
            <TableRow style={{ backgroundColor: '#ebe7e7' }}> 
              <TableCell
                colSpan={columnas.filter(col => !col.hidden).length + 2}
                style={{ fontWeight: 700 }}
              >
                Período {row.PERIODO}
              </TableCell>
            </TableRow>
          )}

          <TableRow style={{ backgroundColor }}>
            <TableCell
              style={{
                paddingLeft: level * 20 + 16,
                width: 55
              }}
            >
              {hasChildren && (
                <IconButton
                  size="small"
                  onClick={() => this.handleToggleExpanded(expandId)}
                >
                  {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
              )}
            </TableCell>

            <TableCell align="center">
              {!isHeader && (
                <Checkbox
                  checked={Number(row.CHECKED) === 1}
                  onChange={() => this.handleCheckCurso(row)}
                />
              )}
            </TableCell>

                {columnas
                .filter(col => !col.hidden)
                .map(col => (
                    <TableCell
                    key={col.id}
                    align={col.align || 'left'}
                    className={classes.bodyCellResponsive}
                    style={{ fontWeight: isHeader ? 600 : 400 }}
                    >
                    {isHeader &&
                    col.id !== 'CODIGO_CURSO' &&
                    col.id !== 'DESCRIPCION_CURSO'
                        ? ''
                        : col.id === 'DIAS'
                        ? String(row.DIAS || '').trim()
                        : row[col.id] || ''}
                    </TableCell>
                ))}
          </TableRow>

          {Array.isArray(row.TREE) &&
            row.TREE.length > 0 &&
            isExpanded &&
            this.renderTreeRows(row.TREE, level + 1)}
        </React.Fragment>
      )
    })
  }

  renderFilterCell = col => {
    const { classes } = this.props;

    if (!col.filterKey || col.hiddenFilter) {
      return <TableCell key={col.id} className={classes.filterStickyCell} />;
    }

    return (
      <TableCell key={col.id} className={classes.filterStickyCell}>
        <TextField
          fullWidth
          defaultValue={this.state[col.filterKey] || ''}
          onChange={e => this.handleFilterChange(col.filterKey, e.target.value)}
          InputProps={{ disableUnderline: false }}
          className={classes.filtroInput}
        />
      </TableCell>
    )
  }

  renderHeaderRows = () => {
    const { classes } = this.props;
    const visibleColumns = columnas.filter(col => !col.hidden);
    const haySeleccionados = Array.isArray(this.state.selection) && this.state.selection.length > 0;

    return (
      <TableHead>
        <TableRow className={classes.headStickyRow}>
          <TableCell
            className={`${classes.headCell} ${classes.selectionHeadCell}`}
            align="center"
            colSpan={2}
          >
            Selección
          </TableCell>

          {visibleColumns.map(col => (
            <TableCell
              key={col.id}
              align="center"
              className={classes.headCell}
            >
              {col.label}
            </TableCell>
          ))}
        </TableRow>

        <TableRow className={classes.filterStickyRow}>
          <TableCell
            className={classes.selectionFilterCell}
            colSpan={2}
          >
            <TextField
              select
              fullWidth
              size="small"
              value={this.state.filtroSeleccion || 'Todos'}
              onChange={e => this.setState({ filtroSeleccion: e.target.value })}
              className={classes.filtroInput}
            >
              <MenuItem value="Todos">Todos</MenuItem>
              <MenuItem value="Seleccionados" disabled={!haySeleccionados}>
                Seleccionados{!haySeleccionados}
              </MenuItem>
            </TextField>
          </TableCell>

          {visibleColumns.map(col => this.renderFilterCell(col))}
        </TableRow>
      </TableHead>
    )
  }

    cerrarModalDias=()=>{
        this.setState({modalDias:false,diaSeleccionado:'',rowPendienteDia:null})
    }

    updateRow = (rows, targetKey, changes) => {
    if (!Array.isArray(rows)) return rows

    return rows.map(item => {
        if (item.CHECK_KEY === targetKey) {
        //console.log('ACTUALIZANDO FILA:', item.CHECK_KEY, changes)
        return {
            ...item,
            ...changes
        }
        }

        if (Array.isArray(item.TREE) && item.TREE.length > 0) {
        return {
            ...item,
            TREE: this.updateRow(item.TREE, targetKey, changes)
        }
        }

        return item
    })
    }

    confirmarDiaSeleccionado = async () => {
    const { diaSeleccionado, rowPendienteDia, rowsdias } = this.state;

    if (!diaSeleccionado) {
        funciones.showToast('w', 'Seleccione un día.')
        return
    }

    if (!rowPendienteDia) {
        funciones.showToast('e', 'No se encontró el curso.')
        return
    }

    const row = rowPendienteDia;
    const targetKey = row.CHECK_KEY;

    const selectedDetails = this.getSelectedDetails(this.state.rows)

    const sameCourseSelected = selectedDetails.find(
        item =>
        item.CODIGO_CURSO === row.CODIGO_CURSO &&
        item.CHECK_KEY !== row.CHECK_KEY
    );

    if (sameCourseSelected) {
        funciones.showToast( 'w','No puede seleccionar el mismo curso en diferente jornada.' )
        return
    }

    const diaInfo = Array.isArray(rowsdias)
        ? rowsdias.find(x => String(x.ID_DIA) === String(diaSeleccionado))
        : null

    const descripcionDia = diaInfo ? String(diaInfo.DESCRIPCION || '').trim() : ''

    try {
        this.setState({
        loadingSeleccion: true,
        modalDias: false
        });

        await this.guardarIntencionMatricula(row, 1, diaSeleccionado);

        this.setState(prevState => {
        let updatedRows = this.updateRow(prevState.rows, targetKey, {
            CHECKED: 1,
            ID_DIAS: diaSeleccionado,
            DIAS: descripcionDia
        });

        if (row.ID_SECCION_PADRE) {
            updatedRows = this.updateParentCheckedFromChildren(
            updatedRows,
            row.ID_SECCION_PADRE
            )
        }

        return {
            rows: updatedRows,
            selection: [...new Set([...prevState.selection, targetKey])],
            loadingSeleccion: false,
            modalDias: false,
            diaSeleccionado: '',
            rowPendienteDia: null
        };
        });
    } catch (error) {
        this.setState({
        loadingSeleccion: false,
        modalDias: true
        })
        funciones.showToast('e', 'No se pudo guardar la selección')
    }
    }

  guardarIntencionMatricula = (row, vtipo,idDia) => {

    const infoCliente=this.state.rowsInformacionCliente?.[0] || {}

    return new Promise((resolve, reject) => {
      new Request
        .post(`${globales.ip}/IntencionMatricula/gestion_oferta`)
        .set({ authorization: 'Bearer ' + Auth.getToken() })
        .send({
          ID_CURSO: row.ID_CURSO,
          ID_DETALLE: row.ORIGINAL_ID_SECCION || row.ID_SECCION,
          ID_CONTROL_MATRICULA: infoCliente.ID_CONTROL_MATRICULA || 0,
          PERIODO:infoCliente.PERIODO || 0,
          ANIO:infoCliente.ANIO || 0,
          ID_MODALIDAD: row.ID_MODALIDAD,
          ID_JORNADA: row.ID_JORNADA,
          ID_DIAS: idDia,
          FECHA_INGRESO: new Date(),
          TIPO: vtipo,
          cuenta_alumno: tokenInfo.user
        })
        .end((err, res) => {
          if (err && String(err).substr(0, 16) === 'Error: Forbidden') {
            window.location.reload()
            return
          }

          if (err) {
            funciones.showToast('e', 'Error al guardar la información.')
            reject(err)
            return
          }

          try {
            const rows = JSON.parse(res.text)

            if (rows.length > 0 && rows[0].RESP !== 'OK') {
              funciones.showToast('e', 'Error al guardar la información.')
              reject(new Error('RESP no OK'));
              return
            }

            if (vtipo === 1) {
              funciones.showToast('s', 'Se guardó la información.')
            } else if (vtipo === 2) {
              funciones.showToast('s', 'Se desmarcó el curso.')
            }

            resolve(res.body)
          } catch (e) {
            funciones.showToast('e', 'Error al guardar la información.')
            reject(e)
          }
        })
    })
  }

  handleResize = () => {
  this.setState({ anchoPantalla: window.innerWidth })
  }

  render() {
    const { classes } = this.props
    const preparedRows = this.prepareRowsForRender(this.state.rows)
    const esPantallaPequena = window.innerWidth <= 600;

    const dias = Array.isArray(this.state.rowsdias) ? this.state.rowsdias : []
    const mitad = Math.ceil(dias.length / 2)

    const izquierda = dias.slice(0, mitad)
    const derecha = dias.slice(mitad)

    // crear filas
    const filas = izquierda.map((item, index) => ({
    left: item,
    right: derecha[index] || null
    }));

    const renderDia = item => (
    <FormControlLabel
        key={item.ID_DIA}
        value={item.ID_DIA}
        control={<Radio color="primary" size="small" />}
        label={
        <span
            style={{
            fontSize: esMovil ? 12 : 13,
            fontWeight: 'bold',
            lineHeight: 1
            }}
        >
            {item.DESCRIPCION}
        </span>
        }
        style={{         
        marginTop: esMovil ? -6 : -4,
        marginBottom: esMovil ? -6 : -4,
        minHeight: esMovil ? 22 : 24,
        width: '100%'
        }}
    />
    );
    
    const botones = [
    {icono: 'Check',nombre:'Guardar', onclick:this.confirmarDiaSeleccionado, display: 'auto'},
    {icono: 'Close',nombre: "Cancelar", onclick:this.cerrarModalDias, display:'auto', color:'red'}
    ]

    if (this.state.isLoggin === true) {
      return (
        <React.Fragment>

          <div style={{ padding: '8px 14px',borderBottom: '2px solid #E5E7EB',margin: '1.5% 5%' }}>
            {/* PLAN */}
            <div style={{ fontSize: 13, color: '#374151', marginTop: 1 ,fontSize:14  }}>
              <span style={{ fontWeight: 700, color: '#042a53' }}>Nivel: </span>{' '}
              {this.state.rowsInformacionCliente?.[0]?.DESCRIPCION_NIVEL || ''}
            </div>

            {/* AÑO Y PERIODO */}
            <div style={{ fontSize: 12,  marginTop: 3 ,fontSize:14  }}>
               <span style={{ fontWeight: 700, color: '#042a53' }}>Oferta Académica Periodo: </span>{' '}
               {this.state.rowsInformacionCliente?.[0]?.ANIO || ''} - {this.state.rowsInformacionCliente?.[0]?.PERIODO || ''}
            </div>
          </div>

          <Paper className={classes.root}>
            <TableContainer className={classes.tableContainer}>
              <Table stickyHeader size="small" className={classes.table}>
                {this.renderHeaderRows()}
                <TableBody>
                {this.state.loadingMain ? (
                    <TableRow>
                    <TableCell
                        colSpan={columnas.filter(col => !col.hidden).length + 2}
                        align="center"
                    >
                        <CircularProgress size={26} />
                    </TableCell>
                    </TableRow>
                ) : preparedRows.length === 0 ? (
                    <TableRow>
                    <TableCell
                        colSpan={columnas.filter(col => !col.hidden).length + 2}
                        align="center"
                    >
                        No se encontraron cursos
                    </TableCell>
                    </TableRow>
                ) : (
                    this.renderTreeRows(preparedRows)
                )}
                </TableBody>
              </Table>
            </TableContainer>
            
            {/* Expandir optativa Loader  y Seleccionar curso Loader */}
            {( this.state.openBackDropInvisible || this.state.loadingSeleccion ) && (
              <div className={classes.overlayLoader}>
                <CircularProgress />
              </div>
            )}
            
            {/*MODAL DIAS*/}
            <Dialog
            open={this.state.modalDias}
            onClose={this.cerrarModalDias}
            maxWidth="xs"
            fullWidth
            scroll='paper'
            PaperProps={{
                style: {
                width: esMovil ? '95%' : 'auto',
                margin: esMovil ? '10px auto' : undefined
                }
            }}
            >
            <DialogTitle style={{ textAlign: 'center', fontWeight: 600 }}>
                Seleccione el día del curso
            </DialogTitle>
                <DialogContent
                style={{
                    maxHeight: esPantallaPequena ? '55vh' : '65vh',
                    overflowY: 'auto',
                    paddingTop: esPantallaPequena ? -10 : -2,
                    paddingBottom: esPantallaPequena ? 4 : 8,
                    paddingLeft: esPantallaPequena ? -12 : 18,
                    paddingRight: esPantallaPequena ? 8 : 16
                }}
                >
                <RadioGroup
                    value={this.state.diaSeleccionado}
                    onChange={e => this.setState({ diaSeleccionado: e.target.value })}
                    style={{ margin: 0, width: '100%' }}
                >
                    {esPantallaPequena ? (
                    dias.map(item => (
                        <div key={item.ID_DIA} style={{ width: '100%' }}>
                        {renderDia(item)}
                        </div>
                    ))
                    ) : (
                    <Grid container spacing={0}>
                        {filas.map((fila, index) => (
                        <React.Fragment key={index}>
                            <Grid item xs={12} sm={6}>
                            {fila.left && renderDia(fila.left)}
                            </Grid>

                            <Grid item xs={12} sm={6}>
                            {fila.right ? renderDia(fila.right) : null}
                            </Grid>
                        </React.Fragment>
                        ))}
                    </Grid>
                    )}
                </RadioGroup>
                </DialogContent>
            <DialogActions
            style={{
                position: 'sticky',
                bottom: 0,
                background: '#fff',
                zIndex: 1
            }}>
                <BarraBotones botones={botones} l={this.l} e={this.e} i={this.i} />
            </DialogActions>
            </Dialog>

          </Paper>
        </React.Fragment>
      );
    } else if (this.state.isLoggin === false) {
      window.location.reload();
      return null
    }

    return null
  }

}) //FIN DE withStyles
